import {Button, RadioGroup, TextInput} from "omoplay";
import React, {useEffect, useState} from "react";
import {listPasswordSpots, updatePassword} from "../../api/spot/spot.api";
import SuspensePopup from "../SuspensePopup";
import {Lock} from "lucide-react";


const DEFAULT_MODE_LABELS = { NONE: '미설정', SINGLE: '전체 단일암호', BRANCH: '진입점별 암호' }

const PasswordType = ({passwordType, benefitPassword, onChangePasswordType, onChangePassword, onChangeValid,
                          allowedModes = ['NONE', 'SINGLE', 'BRANCH'], helpText, modeLabels,
                          showInheritedOnNone = false, inheritedPassword}) => {
    const labels = { ...DEFAULT_MODE_LABELS, ...(modeLabels || {}) }
    const [type, setType] = useState(passwordType)
    const [password, setPassword] = useState(benefitPassword)
    const [entryPoints, setEntryPoints] = useState([])
    const [showEntryPointPassword, setShowEntryPointPassword] = useState(false)
    const [valid, setValid] = useState(false)

    useEffect(() => {
        setPassword(benefitPassword)
        setType(passwordType)
    }, [benefitPassword, passwordType]);

    useEffect(() => {
        if (type === "SINGLE") {
            onChangeValid(password?.length < 4)
            setValid(password?.length < 4)
        } else if (type === "BRANCH") {
            onChangeValid(entryPoints.find((entryPoint) => entryPoint.password.length < 4) != null)
            setValid(entryPoints.find((entryPoint) => entryPoint.password.length < 4) != null)
        } else {
            setValid(true)
        }
    }, [type, password, entryPoints]);
    
    return (
        <>
            <div className="flex gap-2">
                {allowedModes.map((mode) => (
                    <button
                        key={mode}
                        onClick={() => {
                            setType(mode)
                            onChangePasswordType(mode)
                        }}
                        className={`flex-1 py-2 text-xs font-medium rounded-md border transition-all ${
                            type === mode
                                ? 'bg-gray-800 text-white border-gray-800'
                                : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'
                        }`}
                    >
                        {labels[mode]}
                    </button>
                ))}
            </div>
            {helpText && (
                <p className="text-xs text-gray-500 leading-relaxed mt-1">{helpText}</p>
            )}

            {type === 'SINGLE' && (
                <div className="relative animate-in fade-in slide-in-from-top-1 duration-200">
                    <Lock className="absolute left-3 top-2.5 text-gray-400" size={14} />
                    <input
                        type="text"
                        maxLength={4}
                        value={password}
                        onChange={(e) => {
                            if (isNaN(Number(e.target.value))) return
                            setPassword(e.target.value)
                            onChangePassword(e.target.value)
                        }}
                        placeholder="숫자 4자리"
                        className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none text-sm"
                    />
                </div>
            )}

            {type === 'NONE' && showInheritedOnNone && (
                <div className="relative animate-in fade-in slide-in-from-top-1 duration-200">
                    <Lock className="absolute left-3 top-2.5 text-gray-400" size={14} />
                    <input
                        type="text"
                        value={inheritedPassword ?? ''}
                        disabled
                        placeholder="전체 단일암호 상속"
                        className="w-full pl-9 pr-4 py-2 border border-gray-200 rounded-lg text-sm bg-gray-100 text-gray-500 cursor-not-allowed"
                    />
                </div>
            )}

            {type === 'BRANCH' && (
                <button
                    onClick={() => {
                        listPasswordSpots().then(({data}) => {
                            setEntryPoints(data)
                        })
                        setShowEntryPointPassword(true)
                    }}
                    className="w-full py-2 border border-solid border-gray-400 rounded-lg text-sm text-gray-600 hover:bg-gray-50 animate-in fade-in"
                >
                    진입점 비밀번호 일괄 수정
                </button>
            )}
            <SuspensePopup visible={showEntryPointPassword}
                           title="진입점 비밀번호 수정"
                           style={{ maxWidth: "600px", maxHeight: "600px"}}
                           confirmText="저장"
                           confirmDisabled={valid}
                           onConfirm={() => {
                               if (window.confirm("기존에 사용하던 비밀번호가 변경되므로 모든 혜택에 영향을 줍니다.\n그래도 저장하시겠습니까?")) {
                                   updatePassword(entryPoints).then(({data}) => {
                                       if (data !== "success") {
                                           alert(data)
                                       } else {
                                           setShowEntryPointPassword(false)
                                       }
                                   })
                               }
                           }}
                           onClose={() => setShowEntryPointPassword(false)}
            >
                <div className="text-red-500 mb-2">진입점 비밀번호는 각 진입점의 고유 번호이므로 모든 프로젝트와 혜택에 일괄 수정됩니다.</div>
                <div className="flex-col gap-2 h-[300px] overflow-y-auto">
                    {
                        entryPoints.map((entryPoint, index) => {
                            return (
                                <div className="flex-align-center gap-4 w-[300px]">
                                    <div className="flex-1">{entryPoint.name}</div>
                                    <div>
                                        <TextInput type="numeric"
                                                   value={entryPoint.password}
                                                   placeholder="4자리 숫자"
                                                   onChange={(e) => {
                                                       if (isNaN(Number(e.target.value))) return

                                                       const changedEntryPoints = [...entryPoints]
                                                       changedEntryPoints[index].password = e.target.value

                                                       setEntryPoints(changedEntryPoints)
                                                   }}
                                                   maxLength={4}
                                        />
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                {
                    valid && (<div className="text-red-500">비밀번호는 반드시 4자리여야 합니다.</div>)
                }
            </SuspensePopup>
        </>
    )
}

export default PasswordType